<div class="space-1">
  <page-load-header *ngIf="!initialized"></page-load-header>

  <div class="row mb-3">
    <div class="col-md-6">
      <div class="dropdown"><h4>Conferences</h4>
      </div>
    </div>
    <div class="col-md-6 text-right"></div>
  </div>

  <div *ngIf="initialized">
    <div *ngIf="!conferences || conferences.length == 0" class="row no-gutters no-candidates">
      <div class="col-sm-12 my-auto">
        <h1><i class="fas fa-empty-set"></i></h1>
        <h4>You have not registered for any upcoming conferences.</h4>
        <a [routerLink]="['/conferences']" class="btn btn-instagram">Register for a conference</a>
      </div>
    </div>
    <ng-container *ngFor="let conference of conferences; let idx=index ">
      <div *ngIf="idx%5 == 0 " class="mt-1 mb-2">
        <ad-display [isMargin]="false"></ad-display>
      </div>
      <div class="card mb-2">
        <div class="card-body p-4">
          <div class="media d-block d-sm-flex">
            <div class="media-body">
              <div class="media mb-2">
                <div class="media-body">
                  <div class="row">
                    <div class="col-md-10">
                      <h1 class="h5 mb-1">
                        <a [routerLink]="[conference.id, 'schedule']">{{ conference.name }}</a>
                      </h1>

                      <div class="d-md-flex align-items-md-center">
                        <div class="u-ver-divider u-ver-divider--none-md pr-4 mb-3 mb-md-0 mr-4">
                          <h2 class="small text-secondary mb-0">Date</h2>
                          <small class="fas fa-calendar-alt text-secondary align-middle mr-1"></small>
                          <span *ngIf="(conference.startDate | date: 'shortDate') != (conference.endDate | date: 'shortDate')" class="align-middle">{{ conference.startDate | date: 'shortDate' }} - {{ conference.endDate | date: 'shortDate' }}</span>
                          <span *ngIf="(conference.startDate | date: 'shortDate') == (conference.endDate | date: 'shortDate')" class="align-middle">{{ conference.startDate | date: 'shortDate' }} </span>
                        </div>
                        <div class="u-ver-divider u-ver-divider--none-md pr-4 mb-3 mb-md-0 mr-4">
                          <h2 class="small text-secondary mb-0">Total CEUs</h2>
                          <small class="fad fa-certificate text-secondary align-middle mr-1"></small>
                          <span class="align-middle">
                            <span *ngIf="!conference.ceuCountOverride"> {{ conference.ceuCount | pluralizer: 'CEU':'CEUs' }}</span>
                            <span *ngIf="conference.ceuCountOverride"> {{ conference.ceuCountOverride | pluralizer: 'CEU':'CEUs' }}</span>
                          </span>
                        </div>
                        <div class="u-ver-divider u-ver-divider--none-md pr-4 mb-3 mb-md-0 mr-4">
                          <h2 class="small text-secondary mb-0">Modality</h2>
                          <span class="align-middle text-center">{{ conference.conferenceModality }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="text-right">
                        <div class="position-relative d-inline-block text-right">
                          <div class="dropdown">
                            <button class="btn btn-xs btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Actions</button>
                            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                              <a class="dropdown-item" [routerLink]="[conference.id, 'schedule']">View All Events</a>
                              <a class="dropdown-item" [routerLink]="[conference.id, 'my-schedule']">View My Schedule</a>
                              <a class="dropdown-item" target="_blank" [routerLink]="['/conferences', conference.slug]">View Conference Homepage</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
